export default "__VITE_ASSET__DUb276j3__"